import React from 'react'

import Container from 'components/Styled/Container'
import SocialItems from 'components/Navigation/Social'
import MenuItems from 'components/Navigation/MenuItems'
import { Footer, Content, Help, Copy, Menu, Social } from './styled'

const HomepageFooter = () => (
  <Footer id="contact">
    <Container>
      <Content>
        <Help>
          Need Help? Contact our Support Team on <a href="mailto:help@zoeapp.com">help@zoeapp.com</a>
        </Help>

        <Menu>
          <MenuItems isFooterNav />
        </Menu>

        <Social>
          <SocialItems />
        </Social>

        <Copy>© 2019 Zoe. All rights reserved.</Copy>
      </Content>
    </Container>
  </Footer>
)

export default HomepageFooter
